<img src="../../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>
<h1 mat-dialog-title>Update Aging Comments for Invoice Number {{invoiceNumber}}</h1>
<div mat-dialog-content style="position:relative;top:-60px;">
   
  <form 
    (ngSubmit)="onSubmitCommentsUpdate()" 
    novalidate
    [formGroup]="commentsForm" 
    
    style="margin-top:20px;">
    <div class="row margin-top:20px;">
        <div class="col-12">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Comments</mat-label>
                <textarea matInput placeholder="Comments" formControlName="comments"  maxlength="2000" rows="10"></textarea>
            </mat-form-field>
        </div>
    </div>

    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;">Update</button>
    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onClearExistingComments()">Clear Comments</button>
    </form>
       
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="comments" >close</button>
</div>
